import { hookstate, ImmutableObject, State, useHookstate } from "@hookstate/core";
import { devtools } from "@hookstate/devtools";
import { LocaleState, useLocaleState } from "./useLocaleState";

export type ProductBrowserViewType = 'grid' | 'list';

export class ProductBrowserModel {
    view: ProductBrowserViewType = 'grid';
    itemWidth: number = 200;
    expandedView: boolean = true;
}

const storefront_productbrowser_key = 'storefront-productbrowser';
let initialState = new ProductBrowserModel();
const localstorageJson = window.localStorage.getItem(storefront_productbrowser_key);
if (localstorageJson) {
    try {
        initialState = JSON.parse(localstorageJson);
        
        // the expanded view button was hidden, we are going to force it to true in case anyone has it saved as false
        // not ready to delete this yet until I'm sure people don't want this feature back
        initialState.expandedView = true;
    }
    catch (ex) {
        console.error(ex);
    }
}
const productBrowserGlobalStore = hookstate<ProductBrowserModel>(initialState, devtools({ key: 'ProductBrowserState' }));

export class ProductBrowserState {
    private productBrowserState: State<ProductBrowserModel>;
    private localeState: LocaleState

    constructor(productBrowserState: State<ProductBrowserModel>, localeState: LocaleState) {
        this.productBrowserState = productBrowserState;
        this.localeState = localeState;
    }

    get(): ImmutableObject<ProductBrowserModel> {
        return this.productBrowserState.get();
    }

    private saveToLocalStorage() {
        const obj = this.productBrowserState.get();
        let json = '';
        if (obj) {
            json = JSON.stringify(obj);
        }
        window.localStorage.setItem(storefront_productbrowser_key, json);
    }

    setView(value: ProductBrowserViewType) {
        this.productBrowserState.view.set(value);
        this.saveToLocalStorage()
    }

    setExpandedView(value: boolean) {
        this.productBrowserState.expandedView.set(value);
        this.saveToLocalStorage()
    }

    setItemWidth(value: number) {
        this.productBrowserState.itemWidth.set(value);
        this.saveToLocalStorage()
    }
}

export function useProductBrowserState(): ProductBrowserState {
    const productBrowserState = useHookstate<ProductBrowserModel>(productBrowserGlobalStore);
    const localeState = useLocaleState();
    return new ProductBrowserState(productBrowserState, localeState);
}